/** E001 short name not in app registry — use with `useEvent`. */
export const E001_MESSAGE_FAILED_EVENT =
    'Soap.Interfaces.Messages.E001v1_MessageFailed, Soap.Interfaces.Messages';

/** Matches E001Handler / `AuthErrorCodes.NewAccountCreatedTokenRefreshRequired`. */
export const NEW_ACCOUNT_TOKEN_REFRESH_REQUIRED_CODE =
    'e2d3c4b5-a696-4e21-8f32-9158d7e86f48';

/** `bus.tokensRefreshedAfterFailure` — not on `domain-events` channel. */
export const BUS_CHANNEL_INTERNAL = 'internal';

/** Internal bus topic after E001Handler refresh; payload `{ messageId, errorMessage, errorCodes }`. */
export const TOKENS_REFRESHED_AFTER_FAILURE_EVENT = 'tokens-refreshed-after-failure';

/** `useDomainEvent` names — Content + LywLayout subscribe. */
export const REFETCH_C166_DOMAIN_EVENT = 'lyw-refetch-c166-after-token-refresh';
export const REFETCH_C302_DOMAIN_EVENT = 'lyw-refetch-c302-after-token-refresh';
